import { ChangeDetectionStrategy, Component, Inject, PLATFORM_ID, type OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../services/storage.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../services/util.service';

import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { StorageEnum } from '../../enums/storage.enum';
import { SuccessData } from '../../models/success-data.model';
import { isPlatformBrowser } from '@angular/common';
import { NotificationComponent } from '../notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../services/notifications.service';

@Component({
  selector: 'app-success-page',
  imports: [MatDividerModule, MatButtonModule, NotificationComponent, RouterLink],
  templateUrl: './success-page.component.html',
  styleUrl: './success-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessPageComponent implements OnInit {
  private readonly router = inject(Router);
  pageReady = false;
  isAutopay = false;
  data: SuccessData;
  isFutureDatedPayment = false;
  isBrowser = false;
  pageName = 'Success-Page';

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    // eslint-disable-next-line @typescript-eslint/prefer-readonly
    private storage: StorageService,
    // eslint-disable-next-line @typescript-eslint/prefer-readonly
    private utils: UtilService,
    private readonly notifi: NotificationsService,
  ) {
    this.data = new SuccessData();
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.data = this.storage.getSession(StorageEnum.SuccessData);
      this.pageReady = this.inputIsValid();
      this.checkForNotificationMessage();
      this.utils.hideSpinner();
    }
  }

  inputIsValid(): boolean {
    const header = this.data.Header;
    // const details = this.data.Details;
    const cta = this.data.CTAList;

    if (this.utils.isNullOrWhitespace(header)) {
      this.utils.consoleLog('Header is required');
      return false;
    }

    if (cta.length < 1) {
      this.utils.consoleLog('CTA is required');
      return false;
    }

    return true;
  }

  checkForNotificationMessage(): void {
    if (this.data.PostNotificationList.length > 0)
      this.data.PostNotificationList.forEach((notificationData) => {
        this.notifi.addNotification(notificationData.Message, notificationData.NotificationType, this.pageName);
      });
  }

  async nav(link: string): Promise<void> {
    await this.router.navigateByUrl(link);
  }
}
